import { Form, Input, Select, Card, Row, Col, Space, Button } from 'antd'
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import CategorySelect from '../../../components/CategorySelect'
import AuthComponent from '../../../components/AuthComponent'
import { StoreCode } from '../context'
import {
  ReloadOutlined,
  SearchOutlined,
  DownloadOutlined
} from '@ant-design/icons'
import { useState, useEffect, useContext } from 'react'

export default function ProductBasicForm({
  initialValues = {},
  loading,
  isVirtual = true,
  seachType = null,
  seachData = () => {},
  exportData = () => {}
}) {
  const [form] = Form.useForm()
  const { stockStoreType } = useContext(StoreCode)
  const [isGetDefault, setisGetDefault] = useState(false)
  const setCategory = (res, selected) => {
    form.setFieldsValue({
      categoryCode: selected.length ? selected[selected.length - 1].id : ''
    })
  }
  const setDefaultStore = res => {
    form.setFieldsValue({ storeCode: res.storeCode })
    setisGetDefault(true)
  }
  const seachFormData = () => {
    if(seachType === 2){
      seachData( form.getFieldsValue() )
    }else{
      seachData({ formData: form.getFieldsValue() })
    }
  }
  useEffect(() => {
    isGetDefault && seachFormData()
    return () => {}
  }, [isGetDefault, stockStoreType])
  return (
    <Card>
      <Form
        form={form}
        style={{ marginBottom: -20 }}
        wrapperCol={{ style: { marginBottom: 20, marginRight: 20 } }}
        layout='inline'>
        {/* <Row justify='space-between'>
          <Col span={7}> */}
        <Form.Item name='storeCode' label='所属门店'>
          <ShopSelect
            style={{ width: 160 }}
            OnOptionsLoad={setDefaultStore}
            keyVal='storeCode'
          />
        </Form.Item>
        {/* </Col>
          <Col span={7}> */}
        <Form.Item name='categoryCode' label='商品类别'>
          <CategorySelect
            changeOnSelect
            style={{ width: 160 }}
            onChange={setCategory}
          />
        </Form.Item>
        {/* </Col>
          <Col span={7}> */}
        <Form.Item name='productInfo' label='商品信息'>
          <Input placeholder='商品名称/条码/商品编码' />
        </Form.Item>
        <Form.Item>
          <Space>
            <AuthComponent authKey='/inventory/stock/list'>
              <Button
                ghost
                type='primary'
                loading={loading}
                onClick={seachFormData}
                icon={<SearchOutlined />}>
                查询
              </Button>
            </AuthComponent>
            <Button
              type='primary'
              ghost
              onClick={() => form.resetFields()}
              icon={<ReloadOutlined />}>
              重置
            </Button>
            {isVirtual &&(
                <AuthComponent authKey='/inventory/stock/export'>
                  <Button
                      type='primary'
                      onClick={() => exportData(form.getFieldsValue())}
                      icon={<DownloadOutlined />}>
                    导出
                  </Button>
                </AuthComponent>
            )
            }
          </Space>
        </Form.Item>
        {/* </Col>
        </Row> */}
      </Form>
    </Card>
  )
}
